import { getMachinesSearchTaggingOptions } from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@win-reality/react-ui";

import chooseFieldBg from "@/assets/choose-field-bg.webp";

import { MachineCard } from "../Tagging/MachineCard";

const TaggingV2 = () => {
  const {
    data: fields,
    isLoading: loadingFields,
    error,
  } = useQuery({
    ...getMachinesSearchTaggingOptions(),
    select: (result) => result?.machines ?? [],
  });

  return (
    <div
      className="relative h-full w-full bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${chooseFieldBg})` }}
    >
      {/* Left panel with field cards */}
      <div className="absolute left-0 top-0 h-full w-full max-w-[21rem] overflow-y-auto py-6 pl-16 pr-4">
        <div className="flex flex-col gap-3">
          {loadingFields && (
            <>
              <Skeleton className="h-16 w-full" />
              <Skeleton className="h-16 w-full" />
              <Skeleton className="h-16 w-full" />
              <Skeleton className="h-16 w-full" />
            </>
          )}

          {error && (
            <p className="text-sm text-error">
              Error loading SmartParks. {error.message}
            </p>
          )}

          {!loadingFields && fields && fields.length === 0 && (
            <p className="text-sm text-accent-dark-3">
              No SmartParks available for tagging.
            </p>
          )}

          {!loadingFields &&
            fields &&
            fields.length > 0 &&
            fields.map((field) => (
              <MachineCard
                key={field.machineUuid}
                field={field}
                baseRoute="/tagging-v2"
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default TaggingV2;
